document.addEventListener('DOMContentLoaded', function() {
    const intro = document.querySelector('.post_item');
    if (!intro) return console.log('Geen .post_item gevonden');

    intro.style.backgroundColor = '#07d78';
    intro.style.color = 'white';

    const info = intro.querySelector('.post_info'); // underscore zoals in je CSS
    if (info) {
        console.log(info);
        info.style.setProperty('background-color', '#07d78', 'important');
        info.style.backgroundColor = '#fff';
        info.style.color = '#000';

        const title = info.querySelector('.post_title');
        if (title) {
            console.log(title);
            title.style.setProperty('color', '#af2811', 'important');
        }

        const post_txt = info.querySelector('.post_text');
        if (post_txt) {
            console.log(title);
            post_txt.style.setProperty('color', '#af2811', 'important');
        }

    } else {
        console.log('Geen .post_info binnen het eerste .post_item gevonden');
    }

    const swiperback = intro.querySelector('.swipe_element');
    console.log(swiperback);
        if (swiperback) {
            swiperback.style.setProperty('background-color', '#fff', 'important');
        }

    const swiperback_two = intro.querySelectorAll('.swipe_element')[2];
    console.log(swiperback_two);
        if (swiperback_two) {
            swiperback_two.style.setProperty('background-color', '#fff', 'important');
        }



});
